import React from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Tag } from "@foris/avocado-suite";
import styles from "./bookingListFilters.module.scss";

interface BookingListFiltersProps {
  totalBookings: number;
  activeCount: number;
  expiredCount: number;
  activeFilter: string;
  isLoading: boolean;
  className?: string;
  handleFilterChange: (filter: "all" | "active" | "expired") => void;
}

const BookingListFilters = ({
  totalBookings,
  activeCount,
  expiredCount,
  activeFilter,
  isLoading,
  className,
  handleFilterChange,
}: BookingListFiltersProps) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.bookingListFilters, className)}>
      <Tag
        onClick={() => handleFilterChange("all")}
        active={activeFilter === "all"}
        disabled={isLoading}
      >
        {t("booking.booking-list.filters.all")} ({totalBookings})
      </Tag>
      <Tag
        onClick={() => handleFilterChange("active")}
        active={activeFilter === "active"}
        disabled={(activeFilter !== "active" && !activeCount) || isLoading}
      >
        {t("booking.booking-list.filters.active")} ({activeCount})
      </Tag>
      <Tag
        onClick={() => handleFilterChange("expired")}
        active={activeFilter === "expired"}
        disabled={(activeFilter !== "expired" && !expiredCount) || isLoading}
      >
        {t("booking.booking-list.filters.expired")} ({expiredCount})
      </Tag>
    </div>
  );
};

export default BookingListFilters;
